module.exports = __webpack_public_path__ + "static/media/teacher27.04682a25.png";